export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const extractId = (slugId: string): string => {
  // MongoDB ObjectId: 24 hex characters followed by dash or end
  const objectIdMatch = slugId.match(/^([0-9a-f]{24})(?:-|$)/);
  if (objectIdMatch) return objectIdMatch[1];
  // Numeric ID fallback
  return String(parseInt(slugId, 10));
};

export const eventPath = (id: string | number, name?: string): string => {
  const slug = name ? slugify(name) : '';
  return slug ? `/events/${id}-${slug}` : `/events/${id}`;
};

export const eventSeriesPath = (id: string | number, name?: string): string => {
  const slug = name ? slugify(name) : '';
  return slug ? `/event-series/${id}-${slug}` : `/event-series/${id}`;
};
